document.addEventListener("DOMContentLoaded", () => {
  let selectedCapacity = null;
  let selectedBoxVariantId = null;
  let currentCount = 0;
  const selectedItems = {}; // { variantId: quantity }

  const boxOptions = document.querySelectorAll(".gift-box-option");
  const decreaseBtns = document.querySelectorAll(".btn-decrease");
  const increaseBtns = document.querySelectorAll(".btn-increase");
  // カートエリアのボタン・ステータス参照（スコープ付きクラス名）
  const addBtn     = document.querySelector('[data-action="add"]');
  const statusText = document.querySelector('.gc-status .status-text');
  const directCheckoutBtn = document.querySelector('[data-action="direct-checkout"]');
  const orDivider         = document.querySelector('.gc-or-divider');

  // Edit Mode Variables
  const urlParams = new URLSearchParams(window.location.search);
  const editId = urlParams.get("edit_id");
  let isEditMode = false;
  let itemsToRemoveOnSave = [];

  if (editId) {
    isEditMode = true;
    document.getElementById("editModeBanner").style.display = "block";
    if (directCheckoutBtn) directCheckoutBtn.hidden = true;
    if (orDivider) orDivider.hidden = true;
    restoreFromCart(editId);
  }

  // ギフトボックス選択
  boxOptions.forEach((opt) => {
    opt.addEventListener("click", () => {
      if (opt.classList.contains("sold-out")) return;

      boxOptions.forEach((o) => o.classList.remove("selected"));
      opt.classList.add("selected");
      selectedCapacity = parseInt(opt.getAttribute("data-capacity"), 10);
      selectedBoxVariantId = opt.getAttribute("data-variant-id");
      updateStatus();
    });
  });

  // アイテム減少
  decreaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (!selectedCapacity) return alert("先にボックスを選択してください。");

      const card = e.target.closest(".gift-item-card");
      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");

      if (selectedItems[variantId] && selectedItems[variantId] > 0) {
        selectedItems[variantId]--;
        currentCount--;
        countEl.textContent = selectedItems[variantId];
        updateStatus();
      }
    });
  });

  // アイテム増加
  increaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (!selectedCapacity) return alert("先にボックスを選択してください。");
      if (currentCount >= selectedCapacity) {
        return alert(`このボックスには${selectedCapacity}個までしか入りません。`);
      }

      const card = e.target.closest(".gift-item-card");
      if (card.classList.contains("sold-out")) return;

      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");
      const inventoryManagement = card.getAttribute("data-inventory-management");
      const inventoryPolicy = card.getAttribute("data-inventory-policy");
      const inventoryQuantity = parseInt(card.getAttribute("data-inventory-quantity"), 10);
      const currentSelected = selectedItems[variantId] || 0;

      if (
        inventoryManagement === "shopify" &&
        inventoryPolicy !== "continue" &&
        currentSelected >= inventoryQuantity
      ) {
        return alert(`在庫が足りないため追加できません（残り${inventoryQuantity}個）`);
      }

      selectedItems[variantId] = currentSelected + 1;
      currentCount++;
      countEl.textContent = selectedItems[variantId];
      updateStatus();
    });
  });

  // 内訳表示：必要個数ぴったり選び終えたときだけ表示し、商品名を差し替える（金額は固定）
  function updateBreakdown() {
    const breakdown = document.querySelector(".gc-breakdown");
    if (!breakdown) return;

    const isComplete = !!selectedCapacity && !!selectedBoxVariantId && currentCount === selectedCapacity;
    breakdown.hidden = !isComplete;
    if (!isComplete) {
      breakdown.open = false;
      return;
    }

    const names = [];
    for (const [variantId, quantity] of Object.entries(selectedItems)) {
      if (quantity <= 0) continue;
      const card = document.querySelector(`.gift-item-card[data-variant-id="${variantId}"]`);
      const name = card ? card.querySelector("h4").textContent.trim() : "";
      for (let i = 0; i < quantity; i++) {
        names.push(name);
      }
    }

    const slots = breakdown.querySelectorAll(".gc-breakdown-slot");
    slots.forEach((slot, index) => {
      slot.querySelector(".gc-breakdown-name").textContent = names[index] || "";
    });
  }

  function updateStatus() {
    updateBreakdown();
    const cfg = window.GiftSelectionConfig || {};
    const selectText     = cfg.selectPlaceholderText || "ボックスを選択してください";
    const addText        = cfg.addToCartText || "カートに追加する";
    const directText     = cfg.directCheckoutText || "直接購入へ進む";
    const remainingText  = cfg.remainingText || "あと[数量]個でセット価格適用！";
    const completeText   = cfg.completeText || "セット完成！カートに入れましょう🎉";

    if (!addBtn) return;

    if (!selectedCapacity) {
      statusText.innerHTML = selectText;
      addBtn.disabled = true;
      if (directCheckoutBtn) directCheckoutBtn.disabled = true;
      return;
    }

    const diff = selectedCapacity - currentCount;
    if (diff > 0) {
      statusText.innerHTML = remainingText.replace(
        "[数量]",
        `<span class="highlight">${diff}</span>`
      );
      addBtn.disabled = true;
      addBtn.textContent = isEditMode ? "変更を保存する" : addText;
      if (directCheckoutBtn) {
        directCheckoutBtn.disabled = true;
        directCheckoutBtn.textContent = directText;
      }
    } else if (diff === 0) {
      statusText.innerHTML = isEditMode
        ? `<span class="highlight">セット完成！</span>変更を保存しましょう🎉`
        : completeText;
      addBtn.disabled = false;
      addBtn.textContent = isEditMode ? "変更を保存する" : addText;
      if (directCheckoutBtn) {
        directCheckoutBtn.disabled = false;
        directCheckoutBtn.textContent = directText;
      }
    }
  }

  // バンドルID生成
  function generateUUID() {
    return "xxxx-xxxx-4xxx-yxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // 編集モード復元
  async function restoreFromCart(id) {
    try {
      const res = await fetch(
        (window.GiftSelectionConfig?.cartUrl || window.Shopify.routes.root + "cart") + ".js"
      );
      const cart = await res.json();

      let parentItem = null;
      const childItems = [];

      cart.items.forEach((item) => {
        if (item.properties && item.properties["_athenatakt_bundle_id"] === id) {
          if (item.properties["_athenatakt_is_bundle_child"] === "true") {
            childItems.push(item);
          } else {
            parentItem = item;
          }
          itemsToRemoveOnSave.push(item.key);
        }
      });

      if (parentItem) {
        const optionCards = Array.from(boxOptions);
        for (const card of optionCards) {
          if (card.getAttribute("data-variant-id") == parentItem.variant_id) {
            card.click();
            break;
          }
        }
      }

      childItems.forEach((child) => {
        const card = document.querySelector(
          `.gift-item-card[data-variant-id="${child.variant_id}"]`
        );
        if (card) {
          selectedItems[child.variant_id] = child.quantity;
          currentCount += child.quantity;
          const countEl = card.querySelector(".item-count");
          if (countEl) countEl.textContent = child.quantity;
        }
      });

      updateStatus();
    } catch (err) {
      console.error("Failed to restore from cart:", err);
    }
  }

  // 選択中の内容をカートに追加する（失敗時はエラーをthrow）
  async function addBundleToCart() {
    const rootUrl =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    // 編集モードの場合、古い商品をカートから削除する
    if (isEditMode && itemsToRemoveOnSave.length > 0) {
      const updates = {};
      itemsToRemoveOnSave.forEach((key) => (updates[key] = 0));
      try {
        await fetch(rootUrl + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      } catch (err) {
        console.error("Failed to remove old bundle items:", err);
      }
    }

    const bundleId = generateUUID();
    const cartAddUrl = (window.GiftSelectionConfig?.cartAddUrl || rootUrl + "cart/add") + ".js";

    async function postToCart(items) {
      const response = await fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(
          error.description || "在庫状況が変わった可能性があります。ページを更新してご確認ください。"
        );
      }
    }

    // 中身→箱の順に、1件ずつ完了を待って追加する。
    // 検証の結果、Shopifyのカートは「後発の/cart/add.jsリクエストの中身を
    // 先頭に挿入する」LIFO的な並びになることが確認できた（DOM側で見た目のために
    // 並び替えると、チェックアウトの数量欄がDOM順で対応づくため事故る＝
    // 別途 shopify-liquid-lessons.md 参照）。なので見た目上「箱を先頭」にしたい
    // 場合は、逆に箱を最後に追加する。
    const childItems = [];
    for (const [variantId, quantity] of Object.entries(selectedItems)) {
      if (quantity > 0) {
        childItems.push({
          id: variantId,
          quantity: quantity,
          properties: {
            _athenatakt_bundle_id: bundleId,
            _athenatakt_is_bundle_child: "true",
            _athenatakt_badge_text: window.GiftSelectionConfig?.badgeText || "セット内容",
          },
        });
      }
    }
    if (childItems.length > 0) {
      await postToCart(childItems);
    }

    await postToCart([
      {
        id: selectedBoxVariantId,
        quantity: 1,
        properties: {
          _athenatakt_bundle_id: bundleId,
          _athenatakt_edit_url: window.location.pathname,
        },
      },
    ]);
  }

  // カートに追加ボタン
  if (addBtn) {
    addBtn.addEventListener("click", async () => {
      if (!selectedCapacity || currentCount !== selectedCapacity || !selectedBoxVariantId) return;

      addBtn.disabled = true;
      addBtn.textContent = "処理中...";
      if (directCheckoutBtn) directCheckoutBtn.disabled = true;

      try {
        await addBundleToCart();

        if (isEditMode) {
          alert("ギフトの内容を更新しました！");
        }
        window.location.href = window.GiftSelectionConfig?.cartUrl || "/cart";
      } catch (err) {
        console.error(err);
        alert(err.message || "通信エラーが発生しました");
        updateStatus();
      }
    });
  }

  // 直接購入へ進むボタン：カートに追加した上で、そのままチェックアウトへ
  if (directCheckoutBtn) {
    directCheckoutBtn.addEventListener("click", async () => {
      if (!selectedCapacity || currentCount !== selectedCapacity || !selectedBoxVariantId) return;

      addBtn.disabled = true;
      directCheckoutBtn.disabled = true;
      directCheckoutBtn.textContent = "処理中...";

      try {
        await addBundleToCart();
        const rootUrl =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : "/";
        window.location.href = window.GiftSelectionConfig?.checkoutUrl || rootUrl + "checkout";
      } catch (err) {
        console.error(err);
        alert(err.message || "通信エラーが発生しました");
        updateStatus();
      }
    });
  }
});
